export class ResultsCount {

	static selector = '.js-filter-results-count';

	node;
	filter;

	constructor(node, filter) {
		this.node = node;
		this.filter = filter;
	}

	update(count) {
		let self = this;
		self.node.innerHTML = count;
	}
}
